import React, { useState } from "react";
import Button from "../../components/common/Button";
import api from "../../utils/api";
import {
  ROOM_TYPE_OPTIONS,
  CITIES,
  FACILITY_OPTIONS,
  NEPAL_PROVINCES,
  LEASE_OPTIONS,
} from "../../constants/listingOptions";





export default function RoomInquiryPage() {
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    fullName: "",
    phone: "",
    email: "",

    propertyType: "",

    minBudget: "",
    maxBudget: "",

    city: "",

    moveInDate: "",

    leaseDuration: "",
  });

  function change(e) {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  async function submit(e) {
    e.preventDefault();

    if (!form.fullName || !form.phone || !form.propertyType || !form.city) {
      alert("Please fill all required fields.");
      return;
    }

    try {
      setLoading(true);

      await api.post("/inquiries", form);

      alert("Your inquiry has been submitted successfully.");

      setForm({
        fullName: "",
        phone: "",
        email: "",

        propertyType: "",

        minBudget: "",
        maxBudget: "",

        city: "",

        moveInDate: "",

        leaseDuration: "",
      });
    } catch (err) {
      console.error(err);

      alert(err?.response?.data?.message || "Failed to submit inquiry.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="bg-[#F7F7F9] min-h-screen">
      <div className="max-w-5xl mx-auto px-6 py-10">
        {/* Header */}

        <div className="mb-8">
          <h1 className="text-4xl font-bold">Looking For a Room?</h1>

          <p className="text-gray-500 mt-2">
            Tell us your requirements and we'll help you find the perfect
            property.
          </p>
        </div>

        <form onSubmit={submit} className="space-y-8">
          {/* ========================================= */}
          {/* PERSONAL INFORMATION */}
          {/* ========================================= */}

          <section className="bg-white rounded-3xl shadow-sm p-8">
            <h2 className="text-xl font-semibold mb-6">Personal Information</h2>

            <div className="grid md:grid-cols-2 gap-5">
              <div>
                <label className="block text-sm font-medium mb-2">
                  Full Name *
                </label>

                <input
                  type="text"
                  name="fullName"
                  value={form.fullName}
                  onChange={change}
                  placeholder="Enter your full name"
                  className="w-full border rounded-xl px-4 py-3 focus:ring-2 focus:ring-orange-400 outline-none"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Phone Number *
                </label>

                <input
                  type="tel"
                  name="phone"
                  value={form.phone}
                  onChange={change}
                  placeholder="98XXXXXXXX"
                  className="w-full border rounded-xl px-4 py-3 focus:ring-2 focus:ring-orange-400 outline-none"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-2">
                  Email Address
                </label>

                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={change}
                  placeholder="example@gmail.com"
                  className="w-full border rounded-xl px-4 py-3 focus:ring-2 focus:ring-orange-400 outline-none"
                />
              </div>
            </div>
          </section>

          {/* ========================================= */}
          {/* RENTAL REQUIREMENTS */}
          {/* ========================================= */}

          <section className="bg-white rounded-3xl shadow-sm p-8">
            <h2 className="text-xl font-semibold mb-6">Rental Requirements</h2>

            <div className="grid md:grid-cols-2 gap-5">
              <div>
                <label className="block text-sm font-medium mb-2">
                  Property Type *
                </label>

                <select
                  name="propertyType"
                  value={form.propertyType}
                  onChange={change}
                  className="w-full border rounded-xl px-4 py-3"
                >
                  <option value="">Select Property Type</option>

                  {ROOM_TYPE_OPTIONS.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Preferred City *
                </label>

                <select
                  name="city"
                  value={form.city}
                  onChange={change}
                  className="w-full border rounded-xl px-4 py-3"
                >
                  <option value="">Select City</option>

                  {CITIES.map((city) => (
                    <option key={city} value={city}>
                      {city}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Minimum Budget (NPR)
                </label>

                <input
                  type="number"
                  name="minBudget"
                  value={form.minBudget}
                  onChange={change}
                  placeholder="5000"
                  className="w-full border rounded-xl px-4 py-3"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Maximum Budget (NPR)
                </label>

                <input
                  type="number"
                  name="maxBudget"
                  value={form.maxBudget}
                  onChange={change}
                  placeholder="15000"
                  className="w-full border rounded-xl px-4 py-3"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Move-in Date
                </label>

                <input
                  type="date"
                  name="moveInDate"
                  value={form.moveInDate}
                  onChange={change}
                  className="w-full border rounded-xl px-4 py-3"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Lease Duration
                </label>

                <select
                  name="leaseDuration"
                  value={form.leaseDuration}
                  onChange={change}
                  className="w-full border rounded-xl px-4 py-3"
                >
                  <option value="">Select Duration</option>

                  {LEASE_OPTIONS.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </section>

          {/* ========================================= */}
          {/* PROPERTY PREFERENCES */}
          {/* ========================================= */}

          <section className="bg-white rounded-3xl shadow-sm p-8">
            <h2 className="text-xl font-semibold mb-2">Property Preferences</h2>

            <p className="text-sm text-gray-500 mb-6">
              Tell us what kind of property you're looking for.
            </p>

            {/* Preferred Areas */}
            {/* <div className="mb-8"> */}
              {/* <label className="block text-sm font-medium mb-3">
                Preferred Locations
              </label>

              <p className="text-xs text-gray-500 mb-4">
                Select one or more preferred areas.
              </p> */}

              {/* <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                {[
                  "Baneshwor",
                  "New Baneshwor",
                  "Koteshwor",
                  "Kalanki",
                  "Maitighar",
                  "Baluwatar",
                  "Lazimpat",
                  "Samakhusi",
                  "Chabahil",
                  "Boudha",
                  "Maharajgunj",
                  "Kirtipur",
                  "Patan",
                  "Thamel",
                  "Gongabu",
                  "Satdobato",
                ].map((area) => {
                  const active = form.preferredAreas?.includes(area);

                  return (
                    <button
                      key={area}
                      type="button"
                      onClick={() => {
                        const current = form.preferredAreas || [];

                        if (current.includes(area)) {
                          setForm({
                            ...form,
                            preferredAreas: current.filter((a) => a !== area),
                          });
                        } else {
                          setForm({
                            ...form,
                            preferredAreas: [...current, area],
                          });
                        }
                      }}
                      className={`rounded-xl border px-4 py-3 text-sm transition
                      ${
                        active
                          ? "bg-orange-500 border-orange-500 text-white"
                          : "bg-gray-50 hover:bg-orange-50 border-gray-200"
                      }`}
                    >
                      {area}
                    </button>
                  );
                })}
              </div> */}
              {/* Preferred Locations */}
              <div className="mb-8">
                <label className="block text-sm font-medium mb-2">
                  Preferred Locations
                </label>

                <p className="text-xs text-gray-500 mb-4">
                  Enter one or more areas where you would like to find a room.
                  Press Enter or comma after each location.
                </p>

                {/* Location Input */}
                <div className="border border-gray-200 rounded-xl p-3 bg-white focus-within:ring-2 focus-within:ring-orange-400">
                  <div className="flex flex-wrap gap-2">
                    {/* Selected Locations */}
                    {form.preferredAreas?.map((area, index) => (
                      <span
                        key={`${area}-${index}`}
                        className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-3 py-1.5 rounded-full text-sm"
                      >
                        {area}

                        <button
                          type="button"
                          onClick={() => {
                            setForm((prev) => ({
                              ...prev,
                              preferredAreas: prev.preferredAreas.filter(
                                (_, i) => i !== index,
                              ),
                            }));
                          }}
                          className="w-5 h-5 rounded-full flex items-center justify-center hover:bg-orange-200 transition"
                          aria-label={`Remove ${area}`}
                        >
                          ×
                        </button>
                      </span>
                    ))}

                    {/* Input */}
                    <input
                      type="text"
                      placeholder={
                        form.preferredAreas?.length
                          ? "Add another location..."
                          : "e.g. Baneshwor, Koteshwor..."
                      }
                      className="flex-1 min-w-[180px] outline-none text-sm py-1.5"
                      onKeyDown={(e) => {
                        const value = e.target.value.trim();

                        // Add location when Enter is pressed
                        if (e.key === "Enter") {
                          e.preventDefault();

                          if (!value) return;

                          if (!form.preferredAreas?.includes(value)) {
                            setForm((prev) => ({
                              ...prev,
                              preferredAreas: [
                                ...(prev.preferredAreas || []),
                                value,
                              ],
                            }));
                          }

                          e.target.value = "";
                        }

                        // Add location when comma is pressed
                        if (e.key === ",") {
                          e.preventDefault();

                          if (!value) return;

                          if (!form.preferredAreas?.includes(value)) {
                            setForm((prev) => ({
                              ...prev,
                              preferredAreas: [
                                ...(prev.preferredAreas || []),
                                value,
                              ],
                            }));
                          }

                          e.target.value = "";
                        }

                        // Remove last location when Backspace is pressed
                        if (
                          e.key === "Backspace" &&
                          !value &&
                          form.preferredAreas?.length > 0
                        ) {
                          setForm((prev) => ({
                            ...prev,
                            preferredAreas: prev.preferredAreas.slice(0, -1),
                          }));
                        }
                      }}
                    />
                  </div>
                </div>

                {/* Helper text */}
                {form.preferredAreas?.length > 0 && (
                  <p className="text-xs text-gray-500 mt-2">
                    {form.preferredAreas.length} location
                    {form.preferredAreas.length > 1 ? "s" : ""} selected
                  </p>
                )}
              </div>
            {/* </div> */}

            {/* Rooms */}

            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium mb-2">
                  Number of Rooms
                </label>

                <input
                  type="number"
                  min="1"
                  name="rooms"
                  value={form.rooms}
                  onChange={change}
                  placeholder="1"
                  className="w-full border rounded-xl px-4 py-3"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Furnished
                </label>

                <select
                  name="furnished"
                  value={form.furnished}
                  onChange={change}
                  className="w-full border rounded-xl px-4 py-3"
                >
                  <option value="">Select</option>

                  <option value="FULLY">Fully Furnished</option>

                  <option value="SEMI">Semi Furnished</option>

                  <option value="NO">Unfurnished</option>
                </select>
              </div>
            </div>

            {/* Checkboxes */}

            <div className="grid md:grid-cols-3 gap-5 mt-8">
              <label className="flex items-center gap-3">
                <input
                  type="checkbox"
                  name="kitchen"
                  checked={form.kitchen}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      kitchen: e.target.checked,
                    })
                  }
                />
                Kitchen Required
              </label>

              <label className="flex items-center gap-3">
                <input
                  type="checkbox"
                  name="bathroom"
                  checked={form.bathroom}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      bathroom: e.target.checked,
                    })
                  }
                />
                Attached Bathroom
              </label>

              <label className="flex items-center gap-3">
                <input
                  type="checkbox"
                  name="parking"
                  checked={form.parking}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      parking: e.target.checked,
                    })
                  }
                />
                Parking Required
              </label>
            </div>
          </section>

          {/* ========================================= */}
          {/* AMENITIES */}
          {/* ========================================= */}

          <section className="bg-white rounded-3xl shadow-sm p-8">
            <h2 className="text-xl font-semibold mb-2">Preferred Amenities</h2>

            <p className="text-sm text-gray-500 mb-6">
              Select all amenities you would like.
            </p>

            <div className="flex flex-wrap gap-3">
              {FACILITY_OPTIONS.map((item) => {
                const active = form.amenities?.includes(item);

                return (
                  <button
                    key={item}
                    type="button"
                    onClick={() => {
                      const current = form.amenities || [];

                      if (current.includes(item)) {
                        setForm({
                          ...form,
                          amenities: current.filter((a) => a !== item),
                        });
                      } else {
                        setForm({
                          ...form,
                          amenities: [...current, item],
                        });
                      }
                    }}
                    className={`px-5 py-3 rounded-full text-sm border transition
                    ${
                      active
                        ? "bg-orange-500 text-white border-orange-500"
                        : "bg-gray-100 hover:bg-orange-50 border-gray-200"
                    }`}
                  >
                    {item}
                  </button>
                );
              })}
            </div>
          </section>

          {/* ========================================= */}
          {/* TERMS & CONDITIONS */}
          {/* ========================================= */}

          <section className="bg-white rounded-3xl shadow-sm p-8">
            <h2 className="text-xl font-semibold mb-4">Terms & Conditions</h2>

            <label className="flex items-start gap-4">
              <input
                type="checkbox"
                required
                className="mt-1 h-5 w-5 accent-orange-500"
              />

              <span className="text-sm text-gray-600 leading-7">
                I confirm that the information provided above is true and
                accurate. I agree that RoomVetiyo may contact me regarding my
                inquiry and share my requirements with verified property owners
                to help me find a suitable room or property. I have read and
                agree to the{" "}
                <a
                  href="/terms"
                  className="text-orange-500 font-semibold hover:underline"
                >
                  Terms & Conditions
                </a>{" "}
                and{" "}
                <a
                  href="/privacy-policy"
                  className="text-orange-500 font-semibold hover:underline"
                >
                  Privacy Policy
                </a>
                .
              </span>
            </label>
          </section>

          {/* ========================================= */}
          {/* SUBMIT */}
          {/* ========================================= */}

          <section className="bg-white rounded-3xl shadow-sm p-8">
            <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
              <div>
                <h3 className="text-xl font-semibold">Ready to Submit?</h3>

                <p className="text-gray-500 mt-2">
                  Our team and verified property owners will review your inquiry
                  and contact you if a suitable room matching your requirements
                  becomes available.
                </p>
              </div>

              <div className="flex gap-4">
                <Button
                  type="button"
                  variant="outline"
                  onClick={() =>
                    setForm({
                      fullName: "",
                      phone: "",
                      email: "",
                      propertyType: "",
                      minBudget: "",
                      maxBudget: "",
                      city: "",
                      moveInDate: "",
                      leaseDuration: "",
                      preferredAreas: [],
                      rooms: 1,
                      kitchen: false,
                      bathroom: false,
                      parking: false,
                      furnished: "",
                      amenities: [],
                      message: "",
                    })
                  }
                >
                  Reset
                </Button>

                <Button type="submit" variant="primary" disabled={loading}>
                  {loading ? "Submitting..." : "Submit Inquiry"}
                </Button>
              </div>
            </div>
          </section>
        </form>
      </div>
    </div>
  );
}
